import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { Fade } from '@pets-ui/Fade/Fade'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'

export const CardShipping = () => {
  const { campaignCode, campaignId } = useContextCampaignCart()
  const { destructuredData: campaignCouponCalculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)

  const shippingMethods = campaignCouponCalculateResult?.shipping_methods
  const appliedShippingMethod_id = campaignCouponCalculateResult?.applied_shipping_method_id

  const selectedShippingMethod = shippingMethods?.find(method => method.shipping_method_id === appliedShippingMethod_id)

  return (
    <Fade in>
      <Paper elevation={0} p={3} borderRadius={8}>
        <HStack gap={2.5} alignItems="start" flexWrap="nowrap" justifyContent="space-between">
          <VStack>
            <Text fontWeight={600}>
              配送方式：
              {selectedShippingMethod?.name}
            </Text>
            <Text variant="body" color={colors.grey600}>請先選擇配送方式，以便計算免運與運費優惠哦！</Text>
          </VStack>
        </HStack>
      </Paper>
    </Fade>
  )
}
